import { useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';
import { IStorePackageVariation } from 'models/store/i-store-package-variation.interface';
import { IStorePackage } from 'models/store/i-store-package.interface';
import { IWalletCurrency } from 'models/wallet-currency-response.interface';

import { IEvents } from 'hooks/events/useEventsParams';
import { SourceScreenName } from 'hooks/events/useFundsEvents';
import { usePackagePurchase } from 'hooks/usePackagePurchase';

import CheckoutFundsModal from '../completeCheckoutModal/checkoutFundsModal/CheckoutFundsModal';
import ModalPortal from '../ModalPortal';
import PackageCheckoutModalSuccess from './packageCheckoutModalSuccess/PackageCheckoutModalSuccess';
import PackageCheckoutProgressModal from './packageCheckoutProgressModal/PackageCheckoutProgressModal';
import PurchasePackageCheckout from './PurchasePackageCheckout';

type CompletePackageCheckoutOfferModalProps = {
  onClose: () => void;
  onFinished: () => void;
  packageDetails: IStorePackage;
  events?: IEvents;
  selectedOffer: IStorePackageVariation;
};

const CompletePackageCheckoutOfferModal = ({
  packageDetails,
  onClose,
  onFinished,
  events,
  selectedOffer,
}: CompletePackageCheckoutOfferModalProps) => {
  const currencies = useSelector((state: IState): IWalletCurrency[] | null => state.wallet.currencies);

  const {
    confirmationPending,
    fundsRemaining,
    fundsRemainingCurrency,
    isAddFundsOpen,
    isPurchaseFinished,
    isCheckoutInProgress,
    isPurchaseInProgress,
    progressStep,
    purchase,
    setIsAddFundsOpen,
    transactionHash,
  } = usePackagePurchase({ packageDetails, events, selectedOffer });

  const handleClose = () => {
    onFinished();
    onClose();
  };

  return (
    <>
      {isAddFundsOpen && (
        <CheckoutFundsModal
          fundsRemaining={fundsRemaining}
          currency={fundsRemainingCurrency}
          onContinue={() => setIsAddFundsOpen(false)}
          onClose={onClose}
          sourceScreen={SourceScreenName.Store}
        />
      )}
      {isPurchaseInProgress && (
        <ModalPortal
          title="your purchase is processing..."
          className="checkout-modal checkout-modal--pending"
          onClose={onClose}
        >
          <PackageCheckoutProgressModal
            checkoutProgressStep={progressStep!}
            transactionHash={transactionHash}
            packageName={packageDetails.name}
          />
        </ModalPortal>
      )}
      {isCheckoutInProgress && (
        <ModalPortal title="Complete checkout" className="checkout-modal" onClose={onClose}>
          {currencies ? (
            <PurchasePackageCheckout
              confirmationPending={confirmationPending}
              buyPackage={purchase}
              packageDetails={packageDetails}
              selectedOffer={selectedOffer}
            />
          ) : (
            <></>
          )}
        </ModalPortal>
      )}
      {isPurchaseFinished && (
        <ModalPortal
          title="your purchase is complete!"
          className="checkout-modal checkout-modal--success"
          onClose={handleClose}
        >
          <PackageCheckoutModalSuccess
            transactionHash={transactionHash}
            packageDetails={packageDetails}
            onClickClose={onClose}
          />
        </ModalPortal>
      )}
    </>
  );
};
export default CompletePackageCheckoutOfferModal;
